// @mui material components
import Icon from "@mui/material/Icon";

import Intro from "pages/intro";
import Products from "pages/products";
import ProductsDetails from "pages/products/details";
import VideoPlayer from "pages/qrplayer/videos/videoPlayer";
import Support from "pages/support";

const routes = [
  {
    name: "회사소개",
    icon: <Icon>dashboard</Icon>,
    // columns: 1,
    // rowsPerColumn: 2,
    route: "/intro", // Intro 컴포넌트로 라우팅 설정
    component: <Intro />, // Intro 컴포넌트 연결
    key: "intro", // 고유한 key 추가
    collapse: [
      {
        name: "에너지 세이브 존",
        description: "s",
        route: "/intro#energy-save-zone", // Hash URL 설정
      },
      {
        name: "연혁",
        description: "s",
        route: "/intro#history", // Hash URL 설정
      },
      {
        name: "지식재산권 및 인증서",
        description: "s",
        route: "/intro#license", // Hash URL 설정
      },
      {
        name: "오시는 길",
        description: "s",
        route: "/intro#direction", // Hash URL 설정
      },
    ],
    hidden: false,
  },
  {
    name: "제품소개",
    icon: <Icon>storefront</Icon>,
    route: "/products", // Intro 컴포넌트로 라우팅 설정
    component: <Products />, // Intro 컴포넌트 연결
    key: "intro", // 고유한 key 추가
    collapse: [
      {
        name: "에너지 세이브 존",
        description: "s",
        route: "/products#energy-save-zone", // Hash URL 설정
      },
      {
        name: "제품 라인업",
        description: "s",
        route: "/products#line-up", // Hash URL 설정
      },
    ],
    hidden: false,
  },
  {
    name: "고객지원",
    icon: <Icon>help</Icon>,
    route: "/support", // Intro 컴포넌트로 라우팅 설정
    component: <Support />, // Intro 컴포넌트 연결
    key: "support", // 고유한 key 추가
    status: false,
    hidden: true,
  },
  {
    name: "커뮤니티",
    icon: <Icon>chat</Icon>,
    route: "/community",
    component: <Products />,
    key: "community", // 고유한 key 추가
    status: false,
    hidden: true,
  },
  {
    name: "제품가이드",
    icon: <Icon>assignment</Icon>,
    route: "/guide",
    component: <Products />,
    key: "guide", // 고유한 key 추가
    status: false,
    hidden: true,
  },
  {
    name: "제품 상세페이지",
    route: "/products/detail/:productsId",
    component: <ProductsDetails />,
    key: "product-detail",
    hidden: true, // 메뉴에 표시되지 않음
  },
  {
    name: "QR 플레이어",
    route: "/video/:videoId",
    component: <VideoPlayer />,
    key: "video-player",
    hidden: true,
  },
];

export default routes;
